module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "starkbox"
  }, [_c('div', {
    staticClass: "star-list"
  }, _vm._l(([1, 2, 3, 4, 5]), function(item) {
    return _c('span')
  })), _vm._v(" "), _c('div', {
    staticClass: "star-list star-list-post",
    style: ({
      width: _vm.starNumEnd + 'px'
    })
  }, _vm._l(([1, 2, 3, 4, 5]), function(item) {
    return _c('span', {
      staticClass: "active"
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1087f2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/valuationStar.vue
// module id = 908
// module chunks = 1